import { createSelector } from 'reselect';
const selectLimits = state => state.auth.portal.limits;
export const selectHasAccessToMultiKB = createSelector(selectLimits, limits => limits['knowledge-bases'] && limits['knowledge-bases'] > 1);
export const selectKnowledgeBaseLimit = createSelector(selectLimits, limits => limits['knowledge-bases']);